import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { MONTHS, WEEKDAYS } from './date-picker-modal.data';
import { DialogRef } from '@shared/component.dialog';
import { ITEM } from '@utils/constants';

@Component({
  selector: 'app-date-picker-modal',
  standalone: true,
  imports: [],
  templateUrl: './date-picker-modal.component.html',
  styleUrl: './date-picker-modal.component.scss'
})
export class DatePickerModalComponent {
   @Output() dateSelected: EventEmitter<Date | null> = new EventEmitter(); 

  selectedDate = signal<Date | null>(null);
  currentDate = new Date();
  weekDays = WEEKDAYS;

  dialogRef = inject(DialogRef);
  
  get currentMonth(): string {
    
    return MONTHS[this.currentDate.getMonth()];
  }

  get currentYear(): number {
    return this.currentDate.getFullYear();
  }

  get calendarDays() {
    const firstDay = new Date(this.currentYear, this.currentDate.getMonth(), ITEM.EMPTY_LENGTH);
    const lastDay = new Date(this.currentYear, this.currentDate.getMonth() + ITEM.SINGLE_EMISSION, ITEM.EMPTY_LENGTH);
    
    const days = [];
    const firstDayOfWeek = firstDay.getDay();
    
    // Previous month days
    for (let i = firstDayOfWeek - ITEM.SINGLE_EMISSION; i >= ITEM.EMPTY_LENGTH; i--) {
      const date = new Date(firstDay);
      date.setDate(date.getDate() - i - ITEM.SINGLE_EMISSION);
      days.push({ date, otherMonth: true });
    }
    
    // Current month days
    for (let i = 1; i <= lastDay.getDate(); i++) {
      const date = new Date(this.currentYear, this.currentDate.getMonth(), i);
      days.push({ date, otherMonth: false });
    }
    
    // Next month days
    const TOTAL_DAYS_IN_CALENDAR = 42;
    const remainingDays = TOTAL_DAYS_IN_CALENDAR - days.length; // 6 rows * 7 days
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(lastDay);
      date.setDate(date.getDate() + i);
      days.push({ date, otherMonth: true });
    }
    
    return days;
  }


  close() {
    this.dialogRef.close();
  }

  previousMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() - ITEM.SINGLE_EMISSION);
    this.currentDate = new Date(this.currentDate);
  }

  nextMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() + ITEM.SINGLE_EMISSION);
    this.currentDate = new Date(this.currentDate);
  }

  selectDate(date: Date) {
    this.selectedDate.set(date);
  }

  isSelected(date: Date): boolean {
    if (!this.selectedDate()) return false;
    return date.toDateString() === this.selectedDate()?.toDateString();
  }

  confirmSelection() {
    if (this.selectedDate() !== null) {
      this.dateSelected.emit(this.selectedDate());
      this.close();
    }
  }
}
